import {PropertyBase} from "./PropertyBase";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import * as React from "react";
import {ReactElement} from "react";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {faCalculator} from "@fortawesome/free-solid-svg-icons/faCalculator";

export class ButtonProperty extends PropertyBase{
    public Text='';
    public OnClick:()=>void=null;
    public SetText(text)
    {
        this.Text=text;
        return this;
    }


    public SetOnClick(onClick:()=>void){
        this.OnClick=onClick;
        return this;
    }


    public SubRenderer(): React.ReactNode {

        return (
            <React.Fragment>
                <div className={'rncontrol'}>
                    <button onClick={e=>{e.preventDefault(); this.OnClick&&this.OnClick()}} className={'rnbtn rnbtn-primary'}>{this.Text}</button>

                </div>
            </React.Fragment>
        )
    }



}